/**
 * A random id for this tab, sent on every API request (`CLIENT_TAB_ID_HEADER`)
 * so live-update events can say which tab caused them. Module-level, so it
 * lives exactly as long as the page: a reload is a new tab as far as echoes go.
 *
 * Undefined without `crypto.randomUUID` (insecure context); the only cost is
 * that the tab refetches after its own changes as well.
 */
export const CLIENT_TAB_ID: string | undefined = globalThis.crypto?.randomUUID?.()
